import { Navigate } from 'react-router-dom';
import { isExpired } from 'react-jwt';

const RouteProtector = ({ children }) => {
  const token = localStorage.getItem('token');
  if (isExpired(token)) return <Navigate to='/login' />;

  return children;
};

export default RouteProtector;
